<template>
  <div class="card-wrapper">
    <div class="card mb-4">
      <!-- Card header -->
      <div class="card-header">
        <h3 class="mb-0">Agregar registro de precipitación</h3>
      </div>
      <!-- Card body -->
      <div class="card-body">
        <!-- Form groups used in grid -->
        <form ref="form" class="needs-validation" @submit.prevent="save">
          <div class="row">
            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Fecha del Registro</label>

                <el-date-picker
                  v-model="formData.date"
                  v-validate="modelValidations.date"
                  align="center"
                  :editable="false"
                  format="dd-MM-yyyy"
                  name="date"
                  placeholder="Fecha del Registro"
                  suffix-icon="fas fa-calendar-alt"
                  type="date"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>

                <small v-show="date.invalid" class="text-danger">{{ getError('date') }} </small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Descripción</label>

                <el-input
                  v-model="formData.description"
                  v-validate="modelValidations.description"
                  name="description"
                  placeholder="Descripción"
                  type="textarea"
                >
                </el-input>

                <small v-show="description.invalid" class="text-danger">{{ getError('description') }}</small>
              </div>
            </div>

            <div class="col-sm-12">
              <div class="form-group">
                <label class="control-label">Cant. de Milimetros</label>

                <el-input
                  v-model="formData.quantity"
                  v-validate="modelValidations.quantity"
                  name="quantity"
                  placeholder="Cant. de Milimetros"
                >
                </el-input>

                <small v-show="quantity.invalid" class="text-danger">{{ getError('quantity') }}</small>
              </div>
            </div>

            <div class="col-md-12 text-right">
              <base-button native-type="submit" type="primary">Guardar</base-button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vee-validate';
import { DatePicker } from 'element-ui';

export default {
  components: {
    [DatePicker.name]: DatePicker,
  },

  data() {
    return {
      modelValidations: {
        date: {
          required: true,
        },

        quantity: {
          required: true,
          numeric: true,
        },

        description: {
          required: true,
          max: 255,
        },
      },

      formData: {
        date: null,
        quantity: null,
        description: null,
      },
    };
  },

  computed: {
    ...mapFields(['date', 'description', 'quantity']),
  },

  methods: {
    async firstFormSubmit() {
      try {
        return await this.$validator.validateAll();
      } finally {
        this.validated = true;
      }
    },

    save() {
      this.firstFormSubmit().then((res) => {
        if (res) {
          this.$emit('save', this.formData);
        }
      });
    },

    getError(name) {
      return this.errors.first(name);
    },

    cleanForm() {
      this.formData.date = null;
      this.formData.quantity = null;
      this.formData.description = null;
      this.$refs.form.reset();
      this.errors.clear();
      this.$validator.reset();
    },
  },
};
</script>

<style scoped>
.form-group .el-date-editor--datetime,
.form-group .el-date-editor--date {
  width: 100%;
}
</style>
